var React = require('react');

function ToiletAccessibleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"25","cy":"11","r":"4","key":0}),React.createElement("path",{"d":"M54 52l-4.103 1.368a2 2 0 0 1-2.53-1.265l-4.911-14.735A2 2 0 0 0 40.558 36h-11.88a2 2 0 0 1-1.97-1.652L24 19m2 7h10m-16.734 2.145c-4.938 2.86-8.26 8.202-8.26 14.32C11.006 51.596 18.409 59 27.542 59c5.994 0 11.243-3.19 14.143-7.963","strokeLinecap":"square","strokeLinejoin":"round","key":1})]));
}

ToiletAccessibleInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ToiletAccessibleInline;

ToiletAccessibleInline.default = ToiletAccessibleInline;
